/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { ItemSummary, TotalSummary } from 'components';
import { useCartSummary } from 'hooks/useCartSummary';
import './PlaceOrder.css';

export const PlaceOrder = () => {
  const navigate = useNavigate();
  const { search, } = useLocation();
  const [orderNote, setOrderNote] = useState('');

  const {
    cartItems,
    deliveryMode,
    deliveryFee,
    cartSubTotal,
    cartDiscount,
    cartTax,
    cartTotal,
    currencySymbol,
  } = useCartSummary();

  const isCartEmpty = cartItems.length === 0;

  useEffect(() => {
    if (isCartEmpty) navigate(`/${search}`);
  }, [isCartEmpty, navigate, search]);

  return (
    <>
      <div className='YourOrderWrapper'>
        <div className='YourOrderHeading'>
          <h5>Your Order Summary</h5>

          {/* Add button from ProcessToPay instead of anchor tag */}

          <a onClick={() => navigate(`/${search}`)}>Add items +</a>
        </div>

        <ItemSummary
          cartItems={cartItems}
          currencySymbol={currencySymbol}
        />
      </div>

      <TotalSummary
        deliveryMode={deliveryMode}
        deliveryFee={deliveryFee}
        cartSubTotal={cartSubTotal}
        cartDiscount={cartDiscount}
        cartTax={cartTax}
        cartTotal={cartTotal}
        currencySymbol={currencySymbol}
      />

      <div className='SummaryWrap'>
        <h5>Order Notes</h5>

        <textarea
          onChange={({ target, }) => setOrderNote(target.value)}
          placeholder='Additional notes...'
          rows={4}
          className='order__note-textArea'
        ></textarea>
      </div>

      <div className='item-add__bottom__margin' />

      <div className='bottomfixbtn'>
        <button
          onClick={() => {
            navigate(`/processToPay${search}`, { state: { orderNote, }, });
          }}
        >
          place order
        </button>
      </div>
    </>
  );
};
